﻿import $ from "./dQuery";

$(function() {
    $('.nav [data-toggle="tab"]').on('click',
        function (e) {
            e.preventDefault();

            const selectedTab = e.currentTarget as HTMLAnchorElement;
            const tab = selectedTab.parentElement as HTMLElement;
            const tabGroup = tab.parentElement as HTMLElement;

            $(tabGroup).find('.nav-link').removeClass("active");
            $(selectedTab).addClass("active");

            const contentGroup = $(tabGroup).next('.tab-content');
            contentGroup.children().removeClass("show").removeClass("active");
            const clickedTabHref = selectedTab.getAttribute("href") as string;
            contentGroup.find(clickedTabHref).addClass("active").addClass("show");
        });
});